<template>
    <div id="cookbook-root">
        <div id="cookbook-root-wrapper">
            <RecipeAdd @savedRecipe="showAddedRecipe" ref="recipeAdd" />
            <div id="cookbook-header">
                <Header />
            </div>
            <div id="cookbook-body">
                <div v-if="loaded" id="cb-outer-wrapper" class="outer-wrapper">
                    <div class="cb-title-wrapper p-col-12 p-d-print-none">
                        <span class="cb-title noUserSelect page-title"
                            >My Recipe Book</span
                        >
                        <Button
                            id="addRecipebtn"
                            icon="pi pi-plus-circle"
                            class="p-button-outlined"
                            label="Add New Recipe"
                            @click="onAddRecipeBtnClick"
                        />
                    </div>
                    <div
                        v-if="recipeList && recipeList.length > 0"
                        id="cb-wrapper"
                    >
                        <transition name="fastFade" mode="out-in">
                            <div id="cb-tile-view">
                                <DataView
                                    :value="recipeList"
                                    layout="grid"
                                    :paginator="false"
                                    :sortOrder="tileSortOrder"
                                    :sortField="tileSortField"
                                >
                                    <template #header>
                                        <div
                                            id="tile-header"
                                            class="p-grid p-nogutter"
                                        >
                                            <div
                                                class="p-col-6"
                                                style="text-align: left"
                                            >
                                                <span
                                                    v-if="
                                                        recipeList &&
                                                            recipeList.length >
                                                                0
                                                    "
                                                    >{{
                                                        recipeList.length
                                                    }}
                                                    Saved Recipes</span
                                                >
                                            </div>
                                            <div
                                                class="p-col-6"
                                                style="text-align: right"
                                            >
                                                <Dropdown
                                                    v-model="tileSortKey"
                                                    :options="tileSortOptions"
                                                    optionLabel="label"
                                                    placeholder="Most Recent"
                                                    @change="
                                                        onTileSortChange($event)
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </template>
                                    <template #grid="recipe">
                                        <transition
                                            name="fastFade"
                                            mode="out-in"
                                        >
                                            <div
                                                class="cb-tile-card-wrapper p-col-12 p-md-6 p-lg-3"
                                            >
                                                <RecipeCard
                                                    :recipe="recipe.data"
                                                    :title="recipe.data.title"
                                                    :image="recipe.data.image"
                                                    :calories="
                                                        recipe.data.calories
                                                    "
                                                    :carbs="
                                                        recipe.data
                                                            .carbohydrates
                                                    "
                                                    :cooktime="
                                                        recipe.data.cooktime
                                                    "
                                                    :url="recipe.data.source"
                                                    :createdOn="
                                                        recipe.data.addDate
                                                    "
                                                    :showRemove="true"
                                                    @onClick="
                                                        onRecipeClick(
                                                            recipe.data,
                                                            undex
                                                        )
                                                    "
                                                />
                                            </div>
                                        </transition>
                                    </template>
                                </DataView>
                            </div>
                        </transition>
                    </div>
                    <div v-else id="cb-norecipes-wrapper">
                        <h1>Recipe Book is empty</h1>
                        <p>
                            Start saving recipes by trying one of the following
                            options:
                        </p>
                        <ul>
                            <li>Browse recipes on the homepage</li>
                            <li>Search recipe keywords in the header above</li>
                            <li>Click the "Add New Recipe" button</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div id="cookbook-footer">
                <Footer></Footer>
            </div>
        </div>
    </div>
</template>

<script>
import Button from "primevue/button";
import DataView from "primevue/dataview";
import Dropdown from "primevue/dropdown";
import Footer from "../../components/footer/Footer.vue";
import Header from "../../components/header/Header";
import RecipeCard from "../../components/recipeCards/RecipeCard";
import RecipeAdd from "../../components/recipeAdd/RecipeAdd";
import userMixin from "../../store/mixins/user";
import { getRecipesFromApi } from "../../fetchFunctions";

export default {
    mixins: [userMixin],
    props: ["uuid"],
    components: {
        Header,
        Footer,
        Button,
        DataView,
        Dropdown,
        RecipeCard,
        RecipeAdd,
    },
    data() {
        return {
            recipeList: null,
            cbViewBook: false, // false for tile view, true for book list view
            loaded: true,
            tileSortField: "addDate",
            tileSortOrder: -1,
            tileSortOptions: [
                { label: "Most Recent", value: "dateNew" },
                { label: "Oldest", value: "dateOld" },
                { label: "Highest Calories", value: "caloriesHi" },
                { label: "Lowest Calories", value: "caloriesLo" },
                { label: "Highest Carbs", value: "carbohydratesHi" },
                { label: "Lowest Carbs", value: "carbohydratesLo" },
            ],
            tileSortKey: null,
            currentRecipeItem: null,
            currentRecipeData: null,
            loadingRecipe: false,
            defaultSelected: null,
            showMobileRecipeList: false,
            currentIndex: 0,
        };
    },
    created() {
        if (!this.activeUser) {
            return this.$router.push({
                name: "Home",
            });
        }
        if (this.uuid) {
            this.cbViewBook = true;
        }
    },
    async mounted() {
        if (
            this.loggedIn &&
            this.activeUser &&
            this.activeUser.recipeList &&
            Object.keys(this.activeUser.recipeList).length > 0
        ) {
            this.recipeList = this.formattedRecipeList(
                this.activeUser.recipeList
            );
            // Sort list to most recent first
            this.recipeList.sort((a, b) => b.addDate - a.addDate);

            this.defaultSelected = this.recipeList[0];

            if (this.uuid) {
                const res = await this.loadRecipeFromUUID(this.uuid);
                if (res) {
                    if (this.activeUser.recipeList[this.uuid])
                        this.currentRecipeItem = this.activeUser.recipeList[
                            this.uuid
                        ];
                    this.cbViewBook = true;
                    const recipeIndex = this.recipeList.findIndex(
                        x => x.uuid === this.uuid
                    );
                    this.defaultSelected = this.recipeList[recipeIndex];
                    this.currentIndex = recipeIndex;
                } else this.cbViewBook = false;
                return;
            }
        }

        this.loaded = true;
        //  this.loadGourmet();
    },
    watch: {
        loggedIn() {
            if (!this.activeUser) {
                return this.$router.push({
                    name: "Home",
                });
            }
        },
        "$store.state.user.user.recipeList": {
            handler() {
                this.updateRecipeList();
            },
            deep: true,
        },
        cbViewBook() {
            if (
                this.cbViewBook &&
                !this.currentRecipeData &&
                this.recipeList &&
                this.recipeList.length > 0
            ) {
                this.onRecipeClick(this.recipeList[0]);
            }
        },
    },
    methods: {
        onTileSortChange(event) {
            const { value } = event.value;
            const sortValue = event.value;

            switch (value) {
                case "dateNew":
                    this.tileSortOrder = -1;
                    this.tileSortField = "addDate";
                    break;
                case "dateOld":
                    this.tileSortOrder = 1;
                    this.tileSortField = "addDate";
                    break;
                case "caloriesHi":
                    this.tileSortOrder = -1;
                    this.tileSortField = "calories";
                    break;
                case "caloriesLo":
                    this.tileSortOrder = 1;
                    this.tileSortField = "calories";
                    break;
                case "carbohydratesHi":
                    this.tileSortOrder = -1;
                    this.tileSortField = "carbohydrates";
                    break;
                case "carbohydratesLo":
                    this.tileSortOrder = 1;
                    this.tileSortField = "carbohydrates";
                    break;
            }

            this.tileSortKey = sortValue;
        },
        formattedRecipeList(recipeObj) {
            if (recipeObj && Object.keys(recipeObj).length > 0) {
                const out = [];
                for (const i in recipeObj) {
                    const newRecipe = recipeObj[i];
                    newRecipe.uuid = i;
                    out.push(newRecipe);
                }
                return out;
            }
            return false;
        },
        async onRecipeClick(recipe) {
            this.currentRecipeData = null;
            this.currentRecipeItem = recipe;
            if (recipe && recipe.uuid && recipe.dataStatus) {
                const res = await this.loadRecipeFromUUID(recipe.uuid);
                if (res) {
                    this.cbViewBook = true;
                    this.defaultSelected = recipe;
                }
            } else if (recipe && !recipe.dataStatus) {
                // Link recipe, just load data
                this.currentRecipeData = recipe;
                this.cbViewBook = true;
                this.defaultSelected = recipe;
            }
            this.currentIndex = this.recipeList.findIndex(
                x => x.uuid === recipe.uuid
            );
        },
        async onRecipeSelectedFromList(recipe, index) {
            this.currentIndex = index;
            this.currentRecipeData = null;
            if (recipe && recipe.uuid && recipe.dataStatus) {
                await this.loadRecipeFromUUID(recipe.uuid);
            } else if (recipe && !recipe.dataStatus) {
                // Link recipe, just load data
                this.currentRecipeData = recipe;
            }
        },
        async onRecipeSelectedFromListMobile(recipe, index) {
            this.currentRecipeData = null;
            this.currentIndex = index;
            if (recipe && recipe.uuid && recipe.dataStatus) {
                await this.loadRecipeFromUUID(recipe.uuid);
            } else if (recipe && !recipe.dataStatus) {
                // Link recipe, just load data
                this.currentRecipeData = recipe;
            }
            this.showMobileRecipeList = false;
        },
        async loadRecipeFromUUID(uuid) {
            this.loadingRecipe = true;
            const res = await getRecipesFromApi(uuid, "uuid");
            if (
                res &&
                res.status &&
                res.results &&
                res.results[uuid] &&
                res.results[uuid].status &&
                res.results[uuid].data
            ) {
                res.results[uuid].data.uuid = uuid;
                this.currentRecipeData = res.results[uuid].data;
                return true;
            }
        },
        onMenuClick() {
            this.showMobileRecipeList = true;
        },
        onShowRecipeListMobile() {
            const closeBtn = document.querySelector(".p-sidebar-close");
            if (closeBtn)
                closeBtn.onclick = () => {
                    this.showMobileRecipeList = false;
                };
        },
        onHideRecipeListMobile() {
            this.showMobileRecipeList = false;
        },
        updateRecipeList() {
            if (!this.activeUser) return;
            const removed = this.activeUser.recipeList < this.recipeList;
            this.recipeList = this.formattedRecipeList(
                this.activeUser.recipeList
            );
            if (removed) {
                const newIndex = Math.min(
                    this.currentIndex,
                    this.recipeList.length - 1
                );
                this.defaultSelected = this.recipeList[newIndex];
                this.onRecipeSelectedFromList(
                    this.recipeList[newIndex],
                    newIndex
                );
            }
        },
        onAddRecipeBtnClick() {
            this.$refs.recipeAdd.show();
        },
        showAddedRecipe(recipe) {
            this.cbViewBook = true;
            const recipeIndex = this.recipeList.findIndex(
                x => x.uuid === recipe.uuid
            );
            this.defaultSelected = this.recipeList[recipeIndex];
            this.onRecipeSelectedFromList(
                this.recipeList[recipeIndex],
                recipeIndex
            );
        },
    },
};
</script>

<style scoped src="./recipebook.css"></style>
